import { z } from 'zod';
import { lineShape } from './line-shape.js';
import { refineCustomerPaidWithinPrice } from './refine-customer-paid-within-price.js';
export const promotionCreditLineInputSchema = z
    .object(lineShape)
    .superRefine(refineCustomerPaidWithinPrice);
//# sourceMappingURL=line-input.js.map